export const ERROR_PATH = "*";
export const HOME_PATH = "/";
export const ABOUT_PATH = "/about";
export const CONTACT_PATH = "/contactus";
export const SERVICES_PATH = "/services";
export const WEBDESIGN_PATH = "/webdesign";
export const CLOUDHOSTING_PATH = "/cloudhosting";
export const WEBAPPDEV_PATH = "/webappdev";
export const CORPORATE_PATH = "/corporateidentity";
export const SEO_PATH = "/seo";
export const CONSULTANCY_PATH = "/consultancy";
export const CAR_RENTAL_PATH = "/carrentalsystem";
export const FLEET_MANAGMENT_PATH = "/fleetmanagementsystem";
